// `npm start` talks to the local backend, `npm run build` to production — so a
// build can never ship pointing at localhost. REACT_APP_SERVER_LINK points a
// dev server elsewhere (e.g. a throwaway backend for a UI check); development
// only, so it can't leak into a build.
export const serverLink =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_SERVER_LINK || "http://localhost:5001"
    : "https://backend.scesport.com";
